// extracted by mini-css-extract-plugin
export var closeBtn = "zoom-module--close-btn--2IFrc";
export var closed = "zoom-module--closed--KJU0U";
export var fitBtn = "zoom-module--fit-btn--faitz";
export var image = "zoom-module--image--tvifM";
export var mainImage = "zoom-module--mainImage--jJpxw";
export var modalContent = "zoom-module--modal-content--VTSDj";
export var modalOverlay = "zoom-module--modal-overlay--gpQ5I";
export var open = "zoom-module--open--QjHED";
export var wrapper = "zoom-module--wrapper--RJyhx";
export var zoomedImageContainer = "zoom-module--zoomed-image-container--qLWr8";
export var zoomedImageImage = "zoom-module--zoomed-image-image--hdQcY";